import { ModalProps } from 'antd';
import GuideDialog from './NewbieGuideDialog';
import { useTranslate } from '@tolgee/react';

export interface LazadaAuthShopDialogProps extends ModalProps {
  isConfigService: boolean;
  onConfigService: (e: any) => void;
  initialStoreType?: IM_API.Admin.StoreType;
  initialRegion?: General.UpperCaseRegion;
  initialDepartmentIds?: number[];
}

const LazadaAuthShopDialog = (props: LazadaAuthShopDialogProps) => {
  const { t } = useTranslate();

  return (
    <GuideDialog
      defaultPlatform="lazada"
      defaultTitle={t('authShop.添加Lazada店铺')}
      {...props}
      closable
      maskClosable={false}
    />
  );
};

export default LazadaAuthShopDialog;
